import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Importing translation files for English
import enCommon from './en/common.json';
import enInventory from './en/inventory.json';
import enPortfolio from './en/portfolio.json';
import enRevenuePlanner from './en/revenuePlanner.json';

// Importing translation files for German
import deCommon from './de/common.json';
import deInventory from './de/inventory.json';
import dePortfolio from './de/portfolio.json';
import deRevenuePlanner from './de/revenuePlanner.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      common: enCommon,
      inventory: enInventory,
      portfolio: enPortfolio,
      revenuePlanner: enRevenuePlanner,
    },
    de: {
      common: deCommon,
      inventory: deInventory,
      portfolio: dePortfolio,
      revenuePlanner: deRevenuePlanner,
    },
  },

  lng: 'en',
  fallbackLng: 'en',

  ns: ['common', 'inventory', 'portfolio', 'revenuePlanner'],
  defaultNS: 'common',

  interpolation: {
    escapeValue: false,
  },

  returnNull: false,
  returnEmptyString: false,

  debug: false,
});

export default i18n;
